import { httpClient } from "./client";

export interface AfipConstanciaVista {
    cuit: string;
    personaTipo: string;
    nombre: string;
    apellido: string;
    razonSocial: string;
    codCategoriaFiscalTipo?: number | null;
    codResponsableAfipTipo?: number | null;
    domicilioFiscal: {
        localidad: string;
        codigoPostal: string;
        provincia: string;
        direccion: string;
        calle: string;
        nro: string;
    };
    actividades: {
        descripcionRegimen: string;
        idActividad: string;
        nomenclador: string;
        periodo: string;
    }[];
}

export const HttpAfip = {
    obtenerConstanciaInscripcion: (vchCuit: string): Promise<AfipConstanciaVista | null> =>
        httpClient
            .get(`/tienda/afip/constancia/${vchCuit}`)
            .then((resp: { data: AfipConstanciaVista | null } | null) => resp?.data ?? null)
            .catch(() => null),
};
